import {MAX_MOBILE_WIDTH} from '../constants';

/**
 * Custom scrollbar with moving indicator
 */
document.querySelectorAll(".custom-scrollbar").forEach(el => {
    const mobileOnly = el.getAttribute("data-mobile-only");
    const spacingLeftRight = 30; // Corresponds with the global container's padding-left and padding-right
    const scrollbarWrapper = el.querySelector(".custom-scrollbar__wrapper");
    const indicatorContainer = el.querySelector(".container");
    const indicatorWrapper = el.querySelector(".custom-scrollbar__scroll-indicator-wrapper");
    const indicator = el.querySelector(".custom-scrollbar__scroll-indicator");

    const scrollbarPosition = (e) => {
        // Determine scrollbar left position
        const scrollbarPositionLeftInPixels = indicatorWrapper.clientWidth * (e.currentTarget.scrollLeft / scrollbarWrapper.scrollWidth);
        // Determine its transformX percentage
        const scrollbarPositionInPercentage = 100 * (scrollbarPositionLeftInPixels / indicator.clientWidth);

        indicator.style.transform = `translateX(${scrollbarPositionInPercentage}%)`;
    }

    const scrollbar = () => {
        const indicatorWidth = 100 * (window.innerWidth / scrollbarWrapper.scrollWidth);
        scrollbarWrapper.style.paddingLeft =
            mobileOnly && window.innerWidth > MAX_MOBILE_WIDTH ?
                `${spacingLeftRight}px` :
                `${indicatorContainer.getBoundingClientRect().left + spacingLeftRight}px`;

        // Hide scrollbar if there is nothing to scroll
        if (indicatorWidth > 100) {
            indicatorWrapper.style.display = "none"
            return;
        }

        indicatorWrapper.removeAttribute("style");
        indicator.style.width = `${indicatorWidth}%`;
    }

    window.addEventListener('load', scrollbar);
    window.addEventListener('resize', scrollbar);
    scrollbarWrapper.addEventListener('scroll', scrollbarPosition);
});
